import script from "./InstitutePhotoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutePhotoForm.vue?vue&type=script&setup=true&lang=js"

import "./InstitutePhotoForm.vue?vue&type=style&index=0&id=16b5e0d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b5e0d5"]])

export default __exports__